import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
var styles = require('./MailListGroupHeader.scss');
var classNames = require('classnames/bind').bind(styles);
var MailListGroupHeader = /** @class */ (function (_super) {
    tslib_1.__extends(MailListGroupHeader, _super);
    function MailListGroupHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListGroupHeader.prototype.render = function () {
        var isReadingPanePositionOff = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
            ReadingPanePosition.Off;
        var headerClassNames = classNames(styles.outerContainer, 'alignToMailListPersonaLeftPadding', 'alignToMailListPersonaPadding', isReadingPanePositionOff
            ? '$singleLineCirclePersonaDivWidth'
            : 'threeColumnCirclePersonaDivWidth');
        return React.createElement("div", { className: headerClassNames }, this.props.headerText);
    };
    MailListGroupHeader = tslib_1.__decorate([
        observer
    ], MailListGroupHeader);
    return MailListGroupHeader;
}(React.Component));
export default MailListGroupHeader;
//# sourceMappingURL=MailListGroupHeader.js.map